import React, { useEffect, useState } from "react";
import { Modal, Icon } from "antd-mobile";
import { WebpImage } from "@al/akui-mobile";
import PropTypes from "prop-types";
import { SaEventType } from "@al/event-tracking";

import { tracker } from "~/common/tracker";
import Loading from "~/components/ui/Loading";
import useEvent from "~/components/hooks/useEvent";

import ShareCard from "./shareCard";
import styles from "./index.scss";

const __channel__map = {
  2: "WhatsApp",
  3: "Line",
  4: "Instagram",
  5: "Facebook",
  6: "Twitter",
  7: "Messenger",
  8: "Msn",
  9: "Email",
  10: "CopyLink",
  11: "more",
};

const SharePanelNormal = (props) => {
  useEffect(() => {
    if (process.browser && props.visible) {
      tracker.expose({
        sa: {
          pop_id: "pop50001",
          pop_name: "share",
          event: SaEventType?.PopView,
        },
      });
    }
  }, [props.visible]);

  const handleClose = useEvent(() => {
    tracker.popClick({
      sa: {
        pop_id: "pop50001",
        pop_name: "share",
        element_id: "pop5000110",
        element_name: "close",
      },
    });
    props.onClose && props.onClose();
  });
  return (
    <Modal
      popup
      maskClosable
      animationType="slide-up"
      visible={props.visible}
      onClose={handleClose}
      className={styles.share_coupon_modal}
    >
      {props.enableQrCode ? <ShareCard /> : null}
      <div className={styles.new_share}>
        {props.topContent}
        <div className={styles.share_content}>
          <div className={styles.share_title}>
            <div className={styles.share_title_text}>{props.title}</div>
            <div className={styles.close_share} onClick={handleClose}>
              <Icon type="cross" color="#999" />
            </div>
          </div>
          <ul className={styles.channel_list}>
            {(props.channelIds || [5, 2, 6, 3, 4])
              .filter((channelId) => props.supportedChannelIdList.includes(channelId))
              .map((channelId, index) => (
                <li
                  key={channelId}
                  onClick={() => {
                    props.share(channelId, index);
                  }}
                >
                  <WebpImage source={require(`../images/${__channel__map[channelId]}.png`)} width={48} height={48} />
                  <span>{channelId !== 10 ? __channel__map[channelId] : "Copy Link"}</span>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <Loading visible={props.loading} />
    </Modal>
  );
};

SharePanelNormal.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  share: PropTypes.func,
  topContent: PropTypes.string,
  title: PropTypes.string,
  loading: PropTypes.bool,
  enableQrCode: PropTypes.bool,
  supportedChannelIdList: PropTypes.array,
  channelIds: PropTypes.array,
};

export default SharePanelNormal;
